import React from "react";
import { Box } from "@mui/material";

import { createColumnHelper } from "@tanstack/react-table";
import CheckboxColumn from "components/Table/CheckboxColumn";

const columnHelper = createColumnHelper();

const getAccessPointsColumns = (showCheckbox = true) => {
  const baseColumns = [
    /* settings */
    columnHelper.accessor("deviceName", {
      header: "Device Name",
      cell: (info) => <Box>{info.getValue()}</Box>,
    }),
    columnHelper.accessor("portIndex", {
      header: "Port",
      cell: (info) => <Box>{info.getValue()}</Box>,
    }),
    columnHelper.accessor("state", {
      header: "State",
      cell: (info) => {
        const value = info.getValue();

        if (!value || value === "-") {
          return <Box>-</Box>;
        }

        if (
          React.isValidElement(value) &&
          value.type === "img" &&
          !value.props.src
        ) {
          return <Box>-</Box>;
        }

        return <Box>{value}</Box>;
      },
    }),
    columnHelper.accessor("portProfileName", {
      header: "Port Profile",
      cell: (info) => {
        const value = info.getValue();
        const isProfileValid = value != null && value !== "No Profile";

        return <Box>{isProfileValid ? value : "-"}</Box>
      },
    }),
    columnHelper.accessor("PVID", {
      header: "PVID",
      cell: (info) => {
        const selectedProfile = info.row.original.selectedProfile;
        const value = selectedProfile?.PVID ?? info.getValue() ?? "-";
        return <Box>{value}</Box>
      },
    }),
    columnHelper.accessor("allowVlan", {
      header: "Allowed VLANS",
      cell: (info) => {
        const selectedProfile = info.row.original.selectedProfile;
        const value = selectedProfile?.allowVlan ?? info.getValue() ?? "-";

        if (Array.isArray(value) && value.length === 0) return <Box>-</Box>;
        if (Array.isArray(value)) return <Box>{value.join(", ")}</Box>;
        return <Box>{value ?? "-"}</Box>;
      },
    }),
    columnHelper.accessor("tags", {
      header: "Tags",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    /* status */
    columnHelper.accessor("modelName", {
      header: "Model Name",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("lldp", {
      header: "LLDP",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("deviceIp", {
      header: "Device Ip",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),

    /* statistic */
    columnHelper.accessor("txTraffic", {
      header: "Tx Traffic",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("rxTraffic", {
      header: "Rx Traffic",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("txMulticast", {
      header: "Tx Multicast",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("rxMulticast", {
      header: "Rx Multicast",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("txBroadcast", {
      header: "Tx Broadcast",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),

    columnHelper.accessor("rxBroadcast", {
      header: "Rx Broadcast",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("txPackets", {
      header: "Tx Packets",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("rxPackets", {
      header: "Rx Packets",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("totalTraffic", {
      header: "Total Traffic",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
  ];
  return showCheckbox
    ? [CheckboxColumn(columnHelper), ...baseColumns]
    : baseColumns;
};

export default getAccessPointsColumns;
